import { render } from "./MailboxItem.vue?vue&type=template&id=028d8336&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./MailboxItem.vue?vue&type=script&lang=js"
export * from "./MailboxItem.vue?vue&type=script&lang=js"

import "./MailboxItem.vue?vue&type=style&index=0&id=028d8336&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028d8336"]])

export default __exports__